import React, { Component } from 'react';

import Auxiliary from './Auxiliary';
import Nav from './UI/Nav';
import Footer from './UI/Footer';
import BackToTop from './UI/BackToTop';
import AdminMessageBanner from './UI/AdminMessageBanner';
import ProfileNamePrompt from './UI/ProfileNamePrompt';

class Layout extends Component {
    render () {
        // Framed inside the /this-month hub (System card tab): no header, footer or
        // back-to-top - the hub page already has them (Paul, 13 Sep 2026).
        const framed = typeof window !== "undefined" && window.self !== window.top;
        return (
            <Auxiliary>
                {framed ? null : <Nav />}
                <AdminMessageBanner />
                {/* "Please confirm your email" bar removed - email verification switched off (Paul, 26 Oct 2026) */}
                <ProfileNamePrompt />
                <main>
                    {this.props.children}
                </main>
                {framed ? null : <Footer />}
                {framed ? null : <BackToTop />}
            </Auxiliary>
        )
    }
}

export default Layout;

// const mapStateToProps = state => {
//     return {
//         isAuthenticated: state.auth.token !== null
//     };
// };
//
// export default connect( mapStateToProps )( Layout );
